import * as React from 'react'
import BaseIcon from '../../BaseIcon'

export default class IdpAdfsIcon extends BaseIcon {
  getChildren = () => [
    <path fill="none" opacity=".7" d="M0 0h50v50H0z"/>,
    <path d="M23.742 23.807H2.9V4.09h20.842Z" fill="#f1511b"/>,
    <path d="M47.103 23.807H26.258V4.09h20.845Z" fill="#80cc28"/>,
    <path d="M23.741 45.911H2.9V26.194h20.841Z" fill="#00adef"/>,
    <path d="M47.103 45.911H26.258V26.194h20.845Z" fill="#fbbc09"/>
  ]
  getViewBox = () => '0 0 50 50'
}
